import api from './api';

const appointmentService = {
  // Crear cita
  createAppointment: async (data) => {
    const response = await api.post('/appointments', data);
    return response.data;
  },

  // Obtener mis citas
  getMyAppointments: async () => {
    const response = await api.get('/appointments/my');
    return response.data;
  },

  // ¿Tiene el paciente derecho a un seguimiento gratuito con este médico?
  // Solo informativo, para decidir si ofrecer la opción: el backend revalida
  // la regla al crear la cita.
  getFollowUpEligibility: async (doctorId) => {
    const response = await api.get(`/appointments/follow-up-eligibility/${doctorId}`);
    return response.data;
  },

  // Cotizar el valor de una consulta para una fecha y hora (ISO UTC). Endpoint
  // público: el backend aplica la tarifa vigente y el recargo nocturno o
  // dominical. Es el mismo cálculo que queda guardado al crear la cita.
  getQuote: async (scheduledDate) => {
    const response = await api.get('/appointments/quote', { params: { scheduledDate } });
    return response.data;
  },

  // Obtener cita por ID
  getAppointment: async (id) => {
    const response = await api.get(`/appointments/${id}`);
    return response.data;
  },

  // Actualizar estado de cita
  updateStatus: async (id, status) => {
    const response = await api.put(`/appointments/${id}/status`, { status });
    return response.data;
  },

  // Mover la cita a otro horario del mismo médico. El backend revalida el slot
  // contra la agenda y solo lo permite mientras la cita no esté pagada.
  rescheduleAppointment: async (id, scheduledDate) => {
    const response = await api.put(`/appointments/${id}/reschedule`, { scheduledDate });
    return response.data;
  },

  // Cancelar una cita propia (solo antes de pagarla).
  cancelAppointment: async (id, reason) => {
    const response = await api.put(`/appointments/${id}/cancel`, { reason });
    return response.data;
  },

  // Obtener magic link de WhatsApp hacia la sala de la cita
  getWhatsappLink: async (id) => {
    const response = await api.get(`/appointments/${id}/whatsapp-link`);
    return response.data;
  },

  // Obtener historial de chat de una cita (solo doctor o paciente de la cita)
  getChatHistory: async (id) => {
    const response = await api.get(`/appointments/${id}/chat`);
    return response.data;
  }
};

export default appointmentService;
